export default __webpack_public_path__ + "static/media/stream_mock_seats.40d9fe29.png";